export default {
  BaseUrl: `/api/`,
  //donefixme: this needs to be set to the apiKey and clientId of your project
  gapiConfig: {
    apiKey: 'AIzaSyDCEKY90PNLLE4cmOHkdKpgYKDFIpzt7Sw',
    clientId:
      '845319349417-tta0dfsi9hhru46iiipdo7bttq5o7b1h.apps.googleusercontent.com',
    fetch_basic_profile: true,
    scope: 'email profile',
    // see all available scopes here: https://developers.google.com/identity/protocols/googlescopes'
  },
  identityUrl: `https://identitysts-gcp.wyo.gov`,
}
